document.addEventListener('DOMContentLoaded', function () {
    console.log("Swatch King script loaded");

    const sk = document.querySelector('variant-swatch-king');
    const dawn = document.querySelector('[data-dawn-color-picker]');

    console.log("Swatch King:", sk);
    console.log("Dawn Color:", dawn);

    if (sk && dawn) {
        dawn.style.display = "none";
        console.log("Dawn Color hidden");
    }
});